









import { Component, Prop, Vue } from 'vue-property-decorator';
import { FavoritesSpInfo } from '../api/index';
import { windowHelper } from '@tencent/ppd-base-libs';
import { biClick } from '@tencent/fit-bi-sdk';
import { CHANNEL_PAGE_URL } from '@/config/index';

@Component({
  components: {
  },
})

export default class SpItem extends Vue {
  @Prop() spData!: FavoritesSpInfo;
  get showReddot() {
    return this.spData.redFlag === 1;
  }
  onClick() {
    windowHelper.redirect(`${CHANNEL_PAGE_URL}?spId=${this.spData.spId}`, 300);
    biClick('my-favorites-sp.item_click|收藏的优惠商户点击');
  }
}
